import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import Service from './Service';

// Actions
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import {
  updateServiceComment,
  removeService
} from 'store/reducers/appointment/actions';
import { addRepairNotes } from 'store/reducers/repair/actions';
import { addMaintenanceNotes } from 'store/reducers/maintenance/actions';

// Selectors
import {
  getServices,
  getServicesIds
} from 'store/reducers/appointment/selectors';

const mapStateToProps = state => ({
  apptServicesIds: getServicesIds(state),
  apptServices: getServices(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      gtmUserEvent,
      updateServiceComment,
      removeService,
      addRepairNotes,
      addMaintenanceNotes
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Service);



// WEBPACK FOOTER //
// ./src/components/atoms/Service/ServiceContainer.js